// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1AzLk","buttons":"styles_buttons__3bQAX"};